import { createContext, type ReactNode, useMemo } from 'react';
import { useAbortEffect } from '@shared/hooks/useAbortEffect';
import { useDefinedContext } from '@shared/hooks/useDefinedContext';
import type { ListingWithShifts } from '../operations/listings/apiHelpers';
import * as listingApiHelpers from '../operations/listings/apiHelpers';
import { useRestaurant } from './useRestaurant';

export interface PublishedListingsContextValue {
  listings: ListingWithShifts[];
}

export const PublishedListingsContext =
  createContext<PublishedListingsContextValue | null>(null);

export const usePublishedListings = () =>
  useDefinedContext(PublishedListingsContext);

export const PublishedListingsContextProvider = ({
  children,
}: {
  children?: ReactNode;
}) => {
  const { id: restaurantId } = useRestaurant();

  const { data: listings = [] } = useAbortEffect(
    (signal) => listingApiHelpers.getListings(restaurantId, signal),
    [restaurantId],
  );

  const value = useMemo<PublishedListingsContextValue>(
    () => ({ listings }),
    [listings],
  );

  return (
    <PublishedListingsContext.Provider value={value}>
      {children}
    </PublishedListingsContext.Provider>
  );
};
